import { $_app_server } from '@/_helpers'

export const themeService = {
  themes
}

function themes() {
  return $_app_server.get("public/themes")
    .then(response => {
        return response.data
    })
}